import { useAuth } from './useAuth';
import { useAdmins } from 'hooks/api/index';

export const useUserData = () => {
  const { userId } = useAuth();
  const { admins } = useAdmins();

  return admins?.find((item) => item.id === userId);
};
